module.exports = __webpack_public_path__ + "static/1-776391737435b583a614a2b0012ade7b.mp4";